import React, { useContext, useState, useEffect, MouseEventHandler, useCallback } from 'react';
import { UserContext } from '../UserContext';
import { PageContext } from '../PageContext';
import { Col, Container, Row } from 'reactstrap';
import { Button, Toolbar, ToolbarItem } from '@progress/kendo-react-buttons';
import { Grid, GridColumn, GridCellProps, GridDataStateChangeEvent, GridPageChangeEvent,getSelectedState,GridSelectionChangeEvent, GridEditChangeEvent, GridItemChangeEvent, GridCustomCellProps, GridRowProps} from '@progress/kendo-react-grid';
import { Input,Checkbox, CheckboxChangeEvent, InputChangeEvent, Switch, SwitchChangeEvent, NumericTextBox, NumericTextBoxChangeEvent } from '@progress/kendo-react-inputs';
import {SiteEntry,ATOLDeadlines, NewDeadline, StatusDataItem } from '../../services/interfaces';
import { deletePubDeadline, deleteSingleDeadline, getDeadlineList, getPubPathList, saveDeadline } from '../../services/apiAdminService';
import { process, State, DataResult, GroupDescriptor } from '@progress/kendo-data-query';
import { getter } from '@progress/kendo-react-common';
import { EditDescriptor, PagerTargetEvent } from '@progress/kendo-react-data-tools';
import { Dialog, DialogActionsBar } from '@progress/kendo-react-dialogs';
import { Label } from '@progress/kendo-react-labels';
import { data } from 'react-router-dom';
import { ConfirmDialog } from '../ConfirmDialog';
import { PubList, SiteList, StatusList } from '../FormComponents';
import { DropDownList, DropDownListChangeEvent, MultiSelect, MultiSelectChangeEvent } from '@progress/kendo-react-dropdowns';
import { TimePicker, TimePickerChangeEvent } from '@progress/kendo-react-dateinputs';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTrash } from '@fortawesome/free-solid-svg-icons';
interface PageState {
    skip: number;
    take: number;
}

const initialPageState: PageState = { skip: 0, take: 20 };

const initialDataState: State = {
    sort: [{ field: 'category', dir: 'asc' }],
};



interface editProps{
    title: string,
    onSave: (dl:NewDeadline) => void;
    onClose: () => void;
    action:string
}


const NewDialog=(props:editProps)=>{
    const pageContext = useContext(PageContext);

    const [newDeadline,setNewDeadline]=useState<NewDeadline>({
        Type:[],
        Section:[],
        Days:0,
        Time:""
    });


    const setDeadline=()=>{

    }

    const sectionChanged=(e:MultiSelectChangeEvent)=>{
        setNewDeadline({...newDeadline, Section:e.value});
    }

    const typeChanged=(e:MultiSelectChangeEvent)=>{
        let type=e.value;
        switch (e.value){
            case "BOOKED":
                type="EORDER";
                break;
            case "MATERIALS IN":
                type="MATERIALSIN";
                break;
            case "PROOF OUT":
                type="PROOFOUT"
                break;
            case "CORRECTIONS":
                type="ECORR"
                break;
        }
        setNewDeadline({...newDeadline, Type:type});
    }

    const daysChanged = (e:InputChangeEvent)=>{
        setNewDeadline({...newDeadline,Days:Number(e.value)});
    }
     const timeChanged = (e:TimePickerChangeEvent)=>{
        var locale=pageContext?.glSettings.Locale

        const selTime= e.value?.toLocaleTimeString(locale,{hour:'numeric', minute:'2-digit', hour12:true}).toUpperCase()||"";

        setNewDeadline({...newDeadline,Time:selTime});
    }



useEffect(()=>{
    //console.log(newDeadline);

},[newDeadline])


return(
        <>
        <Dialog title="Add New Deadline" onClose={props.onClose} width={500}>
            {/* {showDupConfirm?<ConfirmDialog title='Duplicate Publication' message='This will copy all the settings for the selected publication to a new publication. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDupConfirmWarning} onConfirm={confirmDuplicate}  ></ConfirmDialog>:null}
            {showDelConfirm?<ConfirmDialog title='Delete Publication' message='This will permanently delete the selected publication. This can not be undone. Are you sure you want to continue?' type='WARN' confirmButtonText='Continue' cancelButtonText='Cancel' onClose={hideDelConfirm} onConfirm={deleteThisPub}  ></ConfirmDialog>:null} */}

            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Type:</Label></Col>
                <Col xs="9">
                    <MultiSelect
                        data={["BOOKED","MATERIALS IN","CR MATERIALS IN","PROOF OUT","CR PROOF OUT","CORRECTIONS","PAGINATION"]}
                        onChange={typeChanged}
                    >
                    </MultiSelect>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Section:</Label></Col>
                <Col xs="9">
                    <MultiSelect
                        data={["MAIN","EARLY RUN","ADVANCED","SOFT"]}
                        onChange={sectionChanged}
                    >
                    </MultiSelect>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="12"><Label className='mb-2'>Default Settings:</Label></Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Days:</Label></Col>
                <Col xs="9">
                    <Input type='number' min={0} onChange={daysChanged}></Input>
                </Col>
            </Row>
            <Row className='mb-3'>
                <Col xs="3"><Label className='mb-2'>Time:</Label></Col>
                <Col xs="9">
                    <TimePicker onChange={timeChanged}></TimePicker>
                </Col>
            </Row>
            <DialogActionsBar>
                <Button themeColor={"secondary"}onClick={props.onClose}>Cancel</Button>
                <Button themeColor={"primary"}onClick={() => props.onSave(newDeadline)}>Add</Button>
            </DialogActionsBar>
        </Dialog>
        </>
    )
}

function timeStringToDate(timeStr:string) {
    // Create a new Date object representing today
    const today = new Date();
    
    // Use regex to capture hours, minutes, seconds, and AM/PM
    const match = timeStr.match(/(\d+):(\d+)\s*(AM|PM)?/);
    
    if (!match) return new Date(NaN); // Returns an Invalid Date if no match

    let [_, hoursStr, minutesStr, ampm] = match;
    let hours = parseInt(hoursStr, 10);
    let minutes = parseInt(minutesStr, 10);

    // Convert 12-hour format (AM/PM) to 24-hour format
    if (ampm) {
        if (ampm.toUpperCase() === "PM" && hours < 12) hours += 12;
        if (ampm.toUpperCase() === "AM" && hours === 12) hours = 0;
    }

    // Set the extracted time parts onto today's date
    today.setHours(hours, minutes,0, 0);
    return today;
}


const EditTimer=(props: GridCustomCellProps)=>{
    const pageContext = useContext(PageContext);
   // console.log(props);
    const { dataItem, isInEdit } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    // Create a new Date object representing today
    const fieldVal = timeStringToDate(dataValue.trim());
    console.log(fieldVal);
    const handleChange = (e: TimePickerChangeEvent) => {
        var locale=pageContext?.glSettings.Locale
        //console.log(e);
        const selTime= e.value?.toLocaleTimeString(locale,{hour:'numeric', minute:'2-digit', hour12:true}).toUpperCase();
        if (props.onChange) {
            props.onChange({
                 dataIndex: 0,
                 dataItem: props.dataItem,
                 field: props.field,
                 syntheticEvent: e.syntheticEvent,
                 value: selTime
            });
        }
    };

    return(
        <td {...props.tdProps}>
            {isInEdit ? (
                <TimePicker
                    onChange={handleChange}
                    format="hh:mm a"
                    value={fieldVal}
                >
                </TimePicker>
            ) : (
                dataValue
            )}
        </td>
    )
}

interface NumericChangeEvent {
    dataItem: any;
    field: string;
    value: number;
}

interface KeyboardEventPayload extends React.KeyboardEvent<HTMLInputElement> {
    key: string;
}

const EditNumeric=(props:GridCustomCellProps)=>{
    const { dataItem, isInEdit } = props;
    const field = props.field || '';
    const dataValue = dataItem[field];

    const handleChange = (e: NumericTextBoxChangeEvent): void => {
        if (props.onChange) {
            props.onChange({
                dataIndex:0,
                dataItem: dataItem,
                syntheticEvent: e.syntheticEvent || new Event('change'),
                field: field,
                value: e.value,
            } as any);
        }
    };

  // Completely block the minus/hyphen key from being typed
  const handleKeyDown = (e: KeyboardEventPayload): void => {
    if (e.key === '-' || e.key === 'Minus') {
      e.preventDefault();
    }
  };

  return (
    <td>
        {isInEdit?
            <NumericTextBox
                value={field ? dataItem[field] : undefined}
                onChange={handleChange}
                onKeyDown={handleKeyDown}
                min={0}
            />
        :dataValue}
    </td>
  );

}

export default function AdminRouter (){
    const userContext = useContext(UserContext);
    const pageContext = useContext(PageContext);
    const user = userContext?.user;
    const [deadlines, setDeadlines] = useState<ATOLDeadlines[]>([]);
    const [changes, setChanges] = useState<ATOLDeadlines[]>([]);

    const [siteSelected, setSiteSelected]=useState<SiteEntry>(
        {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:0,
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        }

    );
    const [statusSelected, setStatusSelected]=useState<StatusDataItem>({
        adminOnly:false,
        atolView:false,
        autoEps:false,
        color:"",
        displayOrder:"",
        epsFail:"",
        epsPreflight:"",
        epsSuccess:"",
        readonly:false,
        status:"",
        tempChar1:"",
        tempInt:0,
        userType:"",
        workflowLevel:0
    });

    const [colorSelected, setColorSelected]=useState<{name:string,value:string}>({name:'Select color',value:""})
    const [pubSelected, setPubSelected]=useState<string[]>([]);
    const [siteFilter,setSiteFilter]=useState("");
    const [showNewDialog,setShowNewDialog]=useState(false);
    const [title,setTitle]=useState("");
    const [dataState, setDataState]=useState<State>(initialDataState);
    const [dataResult, setDataResult]=useState<DataResult>(process(deadlines,dataState));
    const [page, setPage] = React.useState<PageState>(initialPageState);
    const [action,setAction]=useState("Edit");
    const [showDeleteSingle, setShowDeleteSingle]=useState(false);
    const [showDeletePub, setShowDeletePub]=useState(false);
    const [dlSelected,setDlSelected]=useState<ATOLDeadlines>()
    const [selectedState, setSelectedState] = React.useState<{
        [id: string]: boolean | number[];
    }>({});
    const [edit, setEdit] = React.useState<EditDescriptor>({});

    const idGetter = getter('pubNum');

    const selectSite=(site:SiteEntry[])=>{
       
        setSiteSelected(site[0] || {
            code:"",
            name:"",
            logo_Prefix:"",
            primary_ip:"",
            backup_ip:"",
            temp_Char:"",
            temp_Int:"",
            vol1_Unc_Path:"",
            vol2_Unc_Path:""
        });
    }

    const selectColor=(event:DropDownListChangeEvent)=>{
        const color:{name:string,value:string}=event.value;
        setColorSelected(color);
    }

    const selectPub=(pub:string[])=>{
        setPubSelected(pub);
    }

    const selectStatus=(status:StatusDataItem)=>{
        setStatusSelected(status);
    }


    const getRouterConfig=()=>{
        const pub=pubSelected;
        const color=colorSelected.value;
        const status=statusSelected.status;
        if (color!=="" && status!=="" && pub.length>0){
            console.log("Get Router Cofifg for:");
            console.log(pub);
            console.log(status);
            console.log(color);
            getPubPathList(pub.toString(),color,status).then(data=>{
                console.log(data);
            });
        }
    }

    const saveChanges=async ()=>{
        
    }
   
    useEffect(()=>{
        console.log(pubSelected);
    },[pubSelected]);

    useEffect(()=>{
         if (siteSelected.code!=""){
            setSiteFilter(siteSelected.code);
        }
    },[siteSelected])

    useEffect(() => {   
        if (user?.loggedIn){
        }else{
            window.location.replace("/Login");
        }
    }, []);


    return (
        <>
        {user?.loggedIn && user.type==5 ?
        <Container fluid>
            <h2>Router Configuration</h2>
            <Toolbar>
                <SiteList setReturnAction={selectSite} value={siteSelected} multi={false} className='toolbarField' valid={true}></SiteList>
                <PubList setReturnAction={selectPub} value={pubSelected} archiveOnly={false} liveOnly={true} type="multi" siteFilter={siteFilter} className='toolbarField' returnField='num' onlineOnly={false} printOnly={false} same={false}></PubList>
                <StatusList setStatus={selectStatus} value={[statusSelected.status]} type='single' enabled={true} limited={true} limitType='autoEPS' className='toolbarField'></StatusList>
                <DropDownList
                    className='toolbarField'
                    fillMode={"outline"}
                    data={[
                        { name: "B&W", value: "B&W" },
                        { name: "SPOT", value: "SPOT" },
                        { name: "PROCESS", value: "PROC" }
                    ]}
                    textField='name'
                    dataItemKey='value'
                    defaultItem={{name:'Select color',value:""}}
                    value ={colorSelected}
                    onChange={selectColor}
                />
                <Button title="Get Settings" className={"toolbarField"} themeColor={'primary'} type="button" onClick={getRouterConfig}>
                    Get Deadlines
                </Button>
            </Toolbar>
            
        </Container>
        : <></>}
        </>
    );
}